import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSpeech } from '../context/SpeechContext';
import { VOICE_INTENTS } from '../services/voiceCommandService';

const findMutantBox = () => (
  document.getElementById('mutant-box-container') ||
  document.getElementById('mutant-box-main') ||
  document.querySelector('[data-agent-module="mutant-box"]') ||
  document.querySelector('.mutantbox-root')
);

const runMutantBoxAction = (localAction) => {
  let attempts = 0;
  const execute = () => {
    const box = findMutantBox();
    if (!box) return false;

    box.scrollIntoView({ behavior: 'smooth', block: 'center' });

    if (localAction === 'generate_mutation') {
      const button = document.getElementById('btn-generate-mutation') ||
        document.querySelector('[data-agent-action="generate-mutation"]');
      if (button) button.click();
    }

    return true;
  };

  const retry = () => {
    if (execute() || attempts >= 12) return;
    attempts += 1;
    window.setTimeout(retry, 150);
  };

  retry();
};

const useGlobalSpeechAction = () => {
  const { transcript, lastCommand } = useSpeech();
  const navigate = useNavigate();
  const processedLocalActionRef = useRef(null);

  useEffect(() => {
    const analysis = lastCommand?.analysis;
    const canNavigateLocally = analysis?.path &&
      (analysis.intent === VOICE_INTENTS.MAP || analysis.intent === VOICE_INTENTS.UI_ACTION);

    if (!canNavigateLocally) return;

    const isDifferentPath = window.location.pathname !== analysis.path;
    if (isDifferentPath) {
      navigate(analysis.path);
    }

    if (analysis.target === 'mutant_box' && processedLocalActionRef.current !== lastCommand.timestamp) {
      processedLocalActionRef.current = lastCommand.timestamp;
      window.setTimeout(
        () => runMutantBoxAction(analysis.localAction || 'scroll_to_mutant_box'),
        isDifferentPath ? 350 : 0
      );
    }
  }, [lastCommand, navigate]);

  useEffect(() => {
    if (!transcript) return;

    const analysis = lastCommand?.analysis;
    if (analysis?.handled) {
      console.log('Comando de Voz Agentico:', analysis);
      return;
    }

    const activeElement = document.activeElement;
    const isTextInput = activeElement && (activeElement.tagName === 'INPUT' || activeElement.tagName === 'TEXTAREA');

    if (isTextInput) {
      const start = activeElement.selectionStart;
      const end = activeElement.selectionEnd;
      const currentValue = activeElement.value;
      const newValue = currentValue.substring(0, start) + transcript + currentValue.substring(end);
      const valueSetter = Object.getOwnPropertyDescriptor(activeElement, 'value').set;
      const prototype = Object.getPrototypeOf(activeElement);
      const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

      if (valueSetter && valueSetter !== prototypeValueSetter) {
        prototypeValueSetter.call(activeElement, newValue);
      } else {
        valueSetter.call(activeElement, newValue);
      }

      activeElement.dispatchEvent(new Event('input', { bubbles: true }));
      activeElement.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      console.log('Comando de Voz Global:', transcript);
    }
  }, [transcript, lastCommand]);
};

export default useGlobalSpeechAction;
